import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  Typography,
  Box,
  FormControlLabel,
  RadioGroup,
  Radio,
  Paper,
  Grid,
  Button,
  Stack
} from '@mui/material';
import { CustomSelect } from '../../../../components/CustomSelect';
import { CustomInput } from '../../../../components/CustomInput';
import { ValidationError } from '../ValidationError';
import { CreateButtonModal } from '../CreateButtonModal';

export const PromotionButtons = ({
  formData,
  onInputChange,
  onButtonChange,
  onAddButton,
  onRemoveButton,
  buttons,
  buttonErrors = {},
  showCreateButtonModal,
  setShowCreateButtonModal,
  onButtonsUpdate
}) => {
  return (
    <>
      <Card sx={{ mb: 3, boxShadow: 2 }}>
        <CardContent>
          <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: 'black' }}>
            Настройки кнопок в карточке акции
          </Typography>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
              Отображать кнопки
            </Typography>
            <RadioGroup
              value={formData.show_buttons ? 'yes' : 'no'}
              onChange={(e) => onInputChange('show_buttons', e.target.value === 'yes')}
              row>
              <FormControlLabel
                value="yes"
                control={<Radio color="primary" />}
                label="Да"
                sx={{ mr: 4 }}
              />
              <FormControlLabel value="no" control={<Radio color="primary" />} label="Нет" />
            </RadioGroup>
          </Box>

          {formData.show_buttons && (
            <Box>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                  Кнопки акции
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Вы можете добавить несколько кнопок с разными ссылками
                </Typography>

                {formData.buttons?.map((button, index) => (
                  <Paper key={index} elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} md={4}>
                        <CustomSelect
                          options={
                            buttons?.buttons?.map((btn) => ({
                              label: `${btn.text_ru} (${btn.button_name})`,
                              value: btn.id
                            })) || []
                          }
                          value={
                            button.button_id
                              ? buttons?.buttons?.find((btn) => btn.id === button.button_id)
                                ? {
                                    label: `${
                                      buttons.buttons.find((btn) => btn.id === button.button_id)
                                        .text_ru
                                    } (${
                                      buttons.buttons.find((btn) => btn.id === button.button_id)
                                        .button_name
                                    })`,
                                    value: button.button_id
                                  }
                                : null
                              : null
                          }
                          onChange={(value) => onButtonChange(index, 'button_id', value)}
                          placeholder="Выберите кнопку"
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <CustomInput
                            placeholder={
                              button.is_external_link
                                ? 'Внешняя ссылка (https://example.com)'
                                : 'Внутренняя ссылка (/path/to/page)'
                            }
                            value={button.link}
                            onChange={(e) => onButtonChange(index, 'link', e.target.value)}
                            fullWidth
                            error={!!buttonErrors[`${index}_link`]}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CustomSelect
                          options={[
                            { value: true, label: 'Внешняя ссылка' },
                            { value: false, label: 'Внутренняя ссылка' }
                          ]}
                          value={
                            button.is_external_link === true
                              ? { value: true, label: 'Внешняя ссылка' }
                              : { value: false, label: 'Внутренняя ссылка' }
                          }
                          onChange={(value) => onButtonChange(index, 'is_external_link', value)}
                          placeholder="Тип ссылки"
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} md={1}>
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() => onRemoveButton(index)}
                          disabled={formData.buttons?.length <= 1}
                          sx={{ minWidth: 'auto', p: 1 }}>
                          ✕
                        </Button>
                      </Grid>
                    </Grid>
                    <ValidationError error={buttonErrors[`${index}_link`]} />
                  </Paper>
                ))}

                <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                  <Button variant="outlined" startIcon={<span>+</span>} onClick={onAddButton}>
                    Добавить кнопку
                  </Button>

                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setShowCreateButtonModal(true)}>
                    Создать новую кнопку
                  </Button>
                </Stack>
              </Box>
            </Box>
          )}
        </CardContent>
      </Card>

      {/* Модальное окно для создания новой кнопки */}
      <CreateButtonModal
        open={showCreateButtonModal}
        onClose={() => setShowCreateButtonModal(false)}
        onButtonCreated={() => {
          // Обновляем список кнопок в родительском компоненте
          if (onButtonsUpdate) {
            onButtonsUpdate();
          }
        }}
      />
    </>
  );
};

PromotionButtons.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onButtonChange: PropTypes.func.isRequired,
  onAddButton: PropTypes.func.isRequired,
  onRemoveButton: PropTypes.func.isRequired,
  buttons: PropTypes.array,
  buttonErrors: PropTypes.object,
  showCreateButtonModal: PropTypes.bool.isRequired,
  setShowCreateButtonModal: PropTypes.func.isRequired,
  onButtonsUpdate: PropTypes.func
};
